var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4385 1.61007C13.3515 1.42678 13.2177 1.27261 13.0521 1.16486C12.8865 1.05711 12.6957 1.00004 12.501 1.00004M13.4385 1.61007L10.9931 2.81818L11.5636 1.61007C11.6506 1.42678 11.7844 1.27261 11.95 1.16486C12.1155 1.05711 12.3064 1.00004 12.501 1.00004M13.4385 1.61007L16.4267 7.94354L23.1071 8.96644C23.2993 8.99491 23.4801 9.07955 23.6289 9.21076C23.7776 9.34197 23.8885 9.51447 23.9487 9.70867C24.009 9.90286 24.0163 10.111 23.9698 10.3093C23.9233 10.5076 23.8248 10.6883 23.6856 10.8307L18.8525 15.7575L19.9935 22.718C20.1396 23.6126 19.2424 24.2941 18.4764 23.8716L12.501 20.5839M13.4385 1.61007C13.3528 1.42569 13.2193 1.27057 13.0534 1.16262C12.8876 1.05466 12.6961 0.998345 12.501 1.00004M12.501 1.00004V20.5839M12.501 20.5839L10.6929 21.5789M6.75001 8.22318L8.57538 7.94354L9.50015 5.98491M5.22138 21.4203L5.0086 22.718C4.86252 23.6126 5.75968 24.2941 6.52687 23.8716L7.50109 23.3354L5.22138 21.4203ZM5.8908 17.3421L6.1496 15.7587L5.35021 14.944L5.8908 17.3421ZM2.95318 12.5L1.31644 10.8319C1.17656 10.6896 1.07752 10.5088 1.03061 10.3101C0.983706 10.1114 0.990822 9.9028 1.05115 9.70816C1.11148 9.51352 1.22259 9.34065 1.3718 9.20928C1.521 9.07792 1.7023 8.99335 1.89499 8.96523L3.17172 8.77033L2.95318 12.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardActive);
export default __webpack_public_path__ + "static/media/dashboard-active.c07748a10e3e6e5582e60fe21dd0ef9e.svg";
export { ForwardRef as ReactComponent };